<template>
  
  <div>
    <b-button @click="editing=false;form=initialForm" v-b-modal.modal-add-product>+ Ajouter un produit au catalogue</b-button><br /><br />
    
    <b-row>
     
      
          <b-col>
          <b-button variant="relief-primary" @click="updateUser">Enregistrer</b-button>
        </b-col>
      </b-row>
    <template v-if="!loaded">
    <b-skeleton height="50px" width="100%"></b-skeleton>
    <b-skeleton height="50px" width="100%"></b-skeleton>
    <b-skeleton height="50px" width="100%"></b-skeleton>
  </template>
    <vue-good-table v-else
      :columns="columns"
      :rows="brand_models"
      :pagination-options="{
        enabled: false,
        
      }"
      :search-options="{
        enabled: true
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
               
              <b-dropdown-item v-b-modal.modal-danger @click="selectedItem=props.row.id">
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Supprimer</span>
              </b-dropdown-item>
              <b-dropdown-item @click="editItem(props.row.id)">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Modifier</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
       
       
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
     
    
    </vue-good-table>

    <b-modal
        id="modal-add-product"
        cancel-variant="outline-secondary"
          cancel-title="Non"
          no-close-on-esc
          no-close-on-backdrop
          
        :ok-title="editing ? 'Modifier le produit' : 'Ajouter le produit'"
        @ok="editing ? updateItem() : addItem(selectedProduct,form.price)"
      
        centered
        :title="editing ? 'Modifier un produit au catalogue' : 'Ajouter un produit au catalogue'"
      >
        <b-card-text>
          <b-form
            class="auth-user-form mt-2"
            @submit.prevent
          >
          <b-form-group 
            v-if="!editing"
            label="Produit"
            label-for="basicInput"
          >
         
          <v-select
                v-model="selectedProduct"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
              
                :options="productChoices"
              />
          </b-form-group>

          <h3 v-if="editing">{{ form.glass.name }}</h3>

          <b-form-group 
            label="Prix"
            label-for="basicInput"
          >
        
          
            <b-form-input
             required
              id="basicInput"
              type="text"
              v-model="form.price"
             
              placeholder="Prix (€)"
             
            />
           
          </b-form-group>
          <template v-if="selectedProduct || editing">


            <b-form-group
              label="Accès au frame drop"
              label-cols="10"
            >
              <b-form-checkbox
                v-model="form.frame_drop_access"
                class="mr-0 mt-50"
                name="is-rtl"
                switch
                inline
              />
            </b-form-group>

            <b-form-group
              label="Recommendation seulement"
              label-cols="10"
            >
              <b-form-checkbox
                v-model="form.recommendation_only"
                class="mr-0 mt-50"
                name="is-rtl"
                switch
                inline
              />
            </b-form-group>

            <h3>Options de personnalisation</h3>

            <b-form-group
              label="Sur-mesure disponible"
              label-cols="10"
            >
              <b-form-checkbox
                v-model="form.custom_fit"
                class="mr-0 mt-50"
                name="is-rtl"
                switch
                inline
              />
            </b-form-group>

            <b-form-group
              label="One size disponible"
              label-cols="10"
            >
              <b-form-checkbox
                v-model="form.one_size"
                class="mr-0 mt-50"
                name="is-rtl"
                switch
                inline
              />
            </b-form-group>

            <b-form-group
              label="Tailles disponibles"
              label-cols="10"
            >
              <b-form-checkbox
                v-model="form.sizes"
                class="mr-0 mt-50"
                name="is-rtl"
                switch
                inline
              />
            </b-form-group>

            <b-form-group
              v-if="form.sizes"
              label="Tailles disponibles"
              label-for="selectedSizes"
            >
            <v-select
                v-model="sizesSelected"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
              
                multiple
                :options="sizesChoices"
              />
            
            </b-form-group>

            <div v-if="detailsloaded">
              <template v-for="(model_part,index) in model_parts" >
                <div v-if="model_part.color_categories.length>0 || model_part.tint_styles.length>0">
                  <b-form-group
                    :label="'Options de personnalisation : '+model_part.name"
                    label-for="model_part.name"
                  >
                  <v-select
                      v-model="selectedModelPartsOptions[index]"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                    
                      multiple
                      :options="choicesModelParts[index]"
                    />
                  
                  </b-form-group>
                </div>
               
              </template>
            </div>
            <div v-else>
              <b-skeleton height="50px" width="100%"></b-skeleton>
            </div>
          </template>
        </b-form>
        
        </b-card-text>
      </b-modal>

        
      <b-modal
          id="modal-danger"
          cancel-variant="outline-secondary"
          cancel-title="Non"
          ok-variant="danger"
          ok-title="Oui"
          @ok="deleteItem(selectedItem)"
          modal-class="modal-danger"
          centered
          title="Êtes-vous sûr ?"
        >
          <b-card-text>
            Attention, cette action est irréversible ! Êtes-vous sûr de vouloir supprimer le produit du catalogue ?
          </b-card-text>
        </b-modal>
  </div>


</template>

<script>
import {BRow,BCol,BModal,BFormFile, BFormCheckbox, BSkeleton,BForm, BFormTextarea,BOverlay,BButton, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest, Auth,Utils} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import UserForm from './UserForm.vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
export default {
  components: { 
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    UserForm,
    BRow,
    BCol,
    BSkeleton,
    BFormFile,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    BForm
  },
  data() {
    return {
      editing:false,
      user:null,
      loaded:false,
      brand_model:null,
      brand_models:[],
      detailGlass:null,
      detailsloaded:false,
      model_parts:null,
      initialForm:{
        color_categories:null,  
        custom_fit:false,
        price:null,
        one_size:false,
        sizes:false,
        available_sizes:'',
        frame_drop_access:false,
        recommendation_only:false,
      },


      form:{
        color_categories:null,  
        custom_fit:false,
        price:null,
        one_size:false,
        sizes:false,
        available_sizes:'',
        frame_drop_access:false,
        recommendation_only:false,
      },
      sizesSelected:[],
      modelPartsToDelete:[],
      sizesChoices:['XS','S','M','L','XL'],
      colorCatChoices:[],
      color_categories:[],
      productChoices:[],
      selectedItem:null,
      loading:true,
      selectedProduct:null,
      choicesModelParts:[],
      selectedModelPartsOptions:[],
      
      columns: [
        {
          label: 'ID',
          field: 'glass.id',
        },
        {
          label: 'Nom',
          field: 'glass.name',
        },
        {
          label: 'Price',
          field: 'price',
        },
        {
          label: 'Action',
          field: 'action',
        }
      ],
    }
  },
  watch: {
    selectedProduct: function(newVal) {
      if(newVal) {
        this.getOptions(newVal.value)
      }
    }
  },
  methods:{
    async editItem(id)
    {
      this.loaded=false
      this.loading=true
      this.editing=true
      let detail_model=await APIRequest.detail('brand-models',id)
      this.form=detail_model
      this.brand_model=detail_model

      if(detail_model.sizes==true)
      {
        this.sizesSelected=detail_model.available_sizes.split(',').filter(size => size.trim() !== '')
      }
      await this.getOptions(detail_model.glass.id)

      this.modelPartsToDelete=[]
      let detailGlass=await APIRequest.detail('glasses',detail_model.glass.id)

      //this.model_parts=detail_model.model_parts;


      for(let i=0;i<detail_model.model_parts.length;i++)
      {
        let realIndex=i;
        for(let j=0;j<detailGlass.model_parts.length;j++)
        {
          if(detail_model.model_parts[i].render_slug==detailGlass.model_parts[j].render_slug)
          {
            realIndex=j;
          }
        }
        if(detail_model.model_parts[i].tint_styles.length>0)
        {
          this.modelPartsToDelete.push(detail_model.model_parts[i].id)
          
         
          let options_tints=[]
          for(let j=0;j<detail_model.model_parts[i].tints.length;j++)
          {
            options_tints.push({value:detail_model.model_parts[i].tints[j].id,title:detail_model.model_parts[i].tints[j].name})
          }
          this.selectedModelPartsOptions[realIndex]=options_tints
        }
        else if(detail_model.model_parts[i].color_categories.length>0)
        {
          this.modelPartsToDelete.push(detail_model.model_parts[i].id)
          console.log('we have colors')
         
          console.log(this.detailGlass.model_parts)
          console.log('researched id : '+detail_model.model_parts[i].id)
          
          let options_colors=[]
          for(let j=0;j<detail_model.model_parts[i].colors.length;j++)
          {
            console.log('color')
            console.log(detail_model.model_parts[i].colors[j])
            options_colors.push({value:detail_model.model_parts[i].colors[j].id,title:detail_model.model_parts[i].colors[j].name})
          }
          
          this.selectedModelPartsOptions[realIndex]=options_colors
        }
      }

      console.log('selectedModelPartsOptions')
      console.log(this.selectedModelPartsOptions)

      this.$bvModal.show('modal-add-product')
      this.loaded=true
      this.loading=false
    },
    async getColorCategories() {
      let color_categories = await APIRequest.list('color-categories')
      this.color_categories=color_categories[0];
      this.colorCatChoices=Utils.formatSelect(this.color_categories,'name','id')
      
    },
    async getOptions(product_id)
    {
      this.detailsloaded=false
      this.detailGlass=await APIRequest.detail('glasses',product_id)
      this.model_parts=this.detailGlass.model_parts;
      this.choicesModelParts=[]
      this.selectedModelPartsOptions=[]
      for(let model_part of this.detailGlass.model_parts)
      {
        if(model_part.tint_styles.length>0)
        {
          let itemChoices=[]
          console.log('we have tints')

          for(let tint_style of model_part.tint_styles)
          {
            console.log('tint_style')
            console.log(tint_style)
            let tint_style_detail=await APIRequest.detail('tint-styles',tint_style.id)
            for(let i=0;i<tint_style_detail.tints.length;i++)
            {
              console.log('tint')
              console.log(tint_style_detail.tints[i])
              itemChoices.push({value:tint_style_detail.tints[i].id,title:tint_style_detail.tints[i].name})
            }
          }
          this.choicesModelParts.push(itemChoices)
          this.selectedModelPartsOptions.push([])
        }
        else if(model_part.color_categories.length>0)
        {
          let itemChoices=[]
          for(let color_category of model_part.color_categories)
          {
            let color_category_detail=await APIRequest.detail('color-categories',color_category.id)
            for(let i=0;i<color_category_detail.colors.length;i++)
            { 
              itemChoices.push({value:color_category_detail.colors[i].id,title:color_category_detail.colors[i].name})
            }
          }
          this.choicesModelParts.push(itemChoices)
          this.selectedModelPartsOptions.push([])
        }
        else
        {
          this.choicesModelParts.push([])
          this.selectedModelPartsOptions.push([])
        }
      }
 
      this.detailsloaded=true
    },
    async deleteItem(id)
    {
      this.loading=true
      try {
        
        await APIRequest.delete('brand-models',id)
        let brand_models=await APIRequest.list_with_request('brand-models','?user='+this.$route.params.id+'&limit=9999')
   
        this.brand_models=brand_models[0];

        let available_glasses_req=await APIRequest.list('glasses')
        let available_glasses=available_glasses_req[0]

        let available_glasses_fin=[]

        for(let i=0;i<available_glasses.length;i++)
        {
          let available=true
          for(let j=0;j<this.brand_models.length;j++)
          {
            if(this.brand_models[j].glass.id==available_glasses[i].id)
            {
              available=false

            }   
          }
          if(available==true)
          {
            available_glasses_fin.push(available_glasses[i])
          }
        }

        this.productChoices=Utils.formatSelect(available_glasses_fin,'name','id')

        this.loaded=true
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Le produit a bien été supprimé du catalogue !",
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        this.loading=false
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Une erreur est survenue.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        
      }

    },

    async addItem(product_id,product_price)
    {
      this.loaded=false
      this.loading=true
      try {

        let model_parts=[]
        for(let i=0;i<this.model_parts.length;i++)
        {
          let item_model_part={}
          if(this.model_parts[i].color_categories.length>0 || this.model_parts[i].tint_styles.length>0)
          {
            let model_parts_options=[]
            for(let j=0;j<this.selectedModelPartsOptions[i].length;j++)
            {
              
              
              model_parts_options.push({id:this.selectedModelPartsOptions[i][j].value})
              
            }

            console.log('options')
            console.log(model_parts_options)

            if(this.model_parts[i].render_type=='lense')
            {
              item_model_part=this.model_parts[i]
              delete item_model_part.id
              delete item_model_part.tints
              item_model_part.tints=model_parts_options
            }
            if(this.model_parts[i].type=='texture_color' || this.model_parts[i].type=='color')
            {
              item_model_part=this.model_parts[i]
              delete item_model_part.id
              delete item_model_part.colors
              console.log('before')
              console.log(item_model_part)
              item_model_part.colors=model_parts_options

              console.log('after')  

              console.log(item_model_part)
            }

            delete item_model_part.glass

          }
          else
          {
            item_model_part=this.model_parts[i]
            delete item_model_part.id
            delete item_model_part.glass
          }
          model_parts.push(item_model_part)
        }

        let a_s='' 



        if(this.form.sizes)
        {
          for(let i=0;i<this.sizesSelected.length;i++)
          {
            a_s+=this.sizesSelected[i]+','
          }
        }

        console.log('siiiize')
        console.log(this.sizesSelected)
        
        let Parameters={
          user:{id:this.$route.params.id},
          price:this.form.price,
          glass:{id:product_id.value},
          model_parts:model_parts,
          custom_fit:this.form.custom_fit,
          one_size:this.form.one_size,
          sizes:this.form.sizes,
          available_sizes:a_s,
          frame_drop_access:this.form.frame_drop_access,
          recommendation_only:this.form.recommendation_only,
        }

        console.log('parameters')
        console.log(Parameters)
        await APIRequest.create('brand-models',Parameters)
        let brand_models=await APIRequest.list_with_request('brand-models','?user='+this.$route.params.id+'&limit=9999')
   
        this.brand_models=brand_models[0];

        let available_glasses_req=await APIRequest.list('glasses')
        let available_glasses=available_glasses_req[0]

        let available_glasses_fin=[]

        for(let i=0;i<available_glasses.length;i++)
        {
          let available=true
          for(let j=0;j<this.brand_models.length;j++)
          {
            if(this.brand_models[j].glass.id==available_glasses[i].id)
            {
              available=false

            }   
          }
          if(available==true)
          {
            available_glasses_fin.push(available_glasses[i])
          }
        }

        this.productChoices=Utils.formatSelect(available_glasses_fin,'name','id')

        this.loaded=true
        this.loading=false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Le produit a bien été ajouté au catalogue !",
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            
          } catch (error) {
            this.loading=false
            
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Une erreur est survenue.',
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            })
            
          }
    },
    async updateItem()
    {
      this.loaded=false
      this.loading=true


      try {

        let model_parts=[]
        for(let i=0;i<this.model_parts.length;i++)
        {
          let item_model_part={}
          if(this.model_parts[i].color_categories.length>0 || this.model_parts[i].tint_styles.length>0)
          {
            let model_parts_options=[]
            for(let j=0;j<this.selectedModelPartsOptions[i].length;j++)
            {
              
              
              model_parts_options.push({id:this.selectedModelPartsOptions[i][j].value})
              
            }

           

            if(this.model_parts[i].render_type=='lense')
            {
              item_model_part=this.model_parts[i]
            
              item_model_part.tints=model_parts_options
            }
            if(this.model_parts[i].type=='texture_color' || this.model_parts[i].type=='color')
            {
              item_model_part=this.model_parts[i]
              
             
              item_model_part.colors=model_parts_options

            
            }

            let real_id=null;

            delete item_model_part.glass
            delete item_model_part.id

            for(let j=0;j<this.brand_model.model_parts.length;j++)
            {
              if(this.model_parts[i].render_slug==this.brand_model.model_parts[j].render_slug)
              {
                real_id=this.brand_model.model_parts[j].id
              }
            }

            await APIRequest.update('model-parts',real_id,item_model_part)

            item_model_part={}
            item_model_part.id=real_id
          }
          else
          {
            let real_id
            for(let j=0;j<this.brand_model.model_parts.length;j++)
            {
              if(this.model_parts[i].render_slug==this.brand_model.model_parts[j].render_slug)
              {
                real_id=this.brand_model.model_parts[j].id
              }
            }
            item_model_part.id=real_id
          }
          model_parts.push(item_model_part)
        }

        let a_s='' 



        if(this.form.sizes)
        {
          for(let i=0;i<this.sizesSelected.length;i++)
          {
            a_s+=this.sizesSelected[i]+','
          }
        }

        console.log('siiiize')
        console.log(this.sizesSelected)
        
        let Parameters={
          user:{id:this.$route.params.id},
          price:this.form.price,
          glass:{id:this.form.glass.id},
          model_parts:model_parts,
          custom_fit:this.form.custom_fit,
          one_size:this.form.one_size,
          sizes:this.form.sizes,
          available_sizes:a_s,
          frame_drop_access:this.form.frame_drop_access,
          recommendation_only:this.form.recommendation_only,
        }

      
        await APIRequest.update('brand-models',this.form.id,Parameters)

      

        let brand_models=await APIRequest.list_with_request('brand-models','?user='+this.$route.params.id+'&limit=9999')
   
        this.brand_models=brand_models[0];

        let available_glasses_req=await APIRequest.list('glasses')
        let available_glasses=available_glasses_req[0]

        let available_glasses_fin=[]

        for(let i=0;i<available_glasses.length;i++)
        {
          let available=true
          for(let j=0;j<this.brand_models.length;j++)
          {
            if(this.brand_models[j].glass.id==available_glasses[i].id)
            {
              available=false

            }   
          }
          if(available==true)
          {
            available_glasses_fin.push(available_glasses[i])
          }
        }

        this.productChoices=Utils.formatSelect(available_glasses_fin,'name','id')

        this.loaded=true
        this.loading=false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Le produit du catalogue a bien été modifié !",
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            
          } catch (error) {
            console.log('error')
            console.log(error)
            console.log(error.response.data)
            console.log(error.response.data.detail)
            console.log(error.response.data.detail[0].msg)
            console.log(error.response.data.detail[0].loc)
            console.log(error.response.data.detail[0].type)
            console.log(error.response.data.detail[0].ctx)
            console.log(error.response.data.detail[0].ctx.label)
            this.loading=false
            
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Une erreur est survenue.',
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            })
            
          }
    },
    async updateUser()
    {
      this.loading=true
      try {
        var color_categories=this.form.color_categories
        this.form.color_categories=[]
        if(color_categories!=null)
        {
          for(var i=0;i<color_categories.length;i++)
          {
            this.form.color_categories[i]={}
            this.form.color_categories[i].id=color_categories[i].value
          }
        }
        await Auth.update_account(this.$route.params.id, this.form)
      } catch (error) {
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Une erreur est survenue.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
      }
      this.loading=false
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'L\'utilisateur a bien été modifié !',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
      this.$router.push({name:'users-b2b'})
    },
    
  },
 
  async mounted()
  {
    this.loaded=false
    //await this.getColorCategories();

    this.user=await Auth.get_user_with_id(this.$route.params.id)
    
    let brand_models=await APIRequest.list_with_request('brand-models','?user='+this.$route.params.id+'&limit=9999')
   
    this.brand_models=brand_models[0];

    let available_glasses_req=await APIRequest.list('glasses')
    let available_glasses=available_glasses_req[0]

    let available_glasses_fin=[]

    for(let i=0;i<available_glasses.length;i++)
    {
      let available=true
      for(let j=0;j<this.brand_models.length;j++)
      {
        if(this.brand_models[j].glass.id==available_glasses[i].id)
        {
          available=false

        }   
      }
      if(available==true)
      {
        available_glasses_fin.push(available_glasses[i])
      }
    }

    this.productChoices=Utils.formatSelect(available_glasses_fin,'name','id')

    this.loaded=true
    this.loading=false
  },
  
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>